import qs from "qs";
import CustomStore from "devextreme/data/custom_store";
import {
  handleGetSessionStorage,
  handleError,
  handleParams,
} from "../../services/helpers";
import store from "../../store/Store";
import api from "../../services/api";

function handleInsert(values) {
  const { auth } = handleGetSessionStorage();
  const record = {
    id: null,
    idPessoaEmpresa: auth.empresa,
    ...values,
    usuario: auth.nomeUsuario,
    excluido: false,
  };

  return api
    .post("/Escolaridade", record)
    .then((res) => res)
    .catch((err) => handleError("Erro ao incluir", err));
}

function handleLoad(loadOptions) {
  const { auth } = handleGetSessionStorage();
  const record = {
    idPessoaEmpresa: auth.empresa,
    descricao: "",
  };
  const newRecord = handleParams(record, loadOptions);
  const url = `/Escolaridade/GetPorEmpresa?${qs.stringify(newRecord)}`;

  return api
    .get(url)
    .then((res) => {
      const { data, totalCount } = res.data;
      return {
        data,
        totalCount,
      };
    })
    .catch((err) => handleError("Erro ao incluir", err));
}

function handleUpdate(values) {
  const { selected } = store.getState().Escolaridade;

  return api
    .put("/Escolaridade", selected)
    .then((res) => res)
    .catch((err) => handleError("Erro ao incluir", err));
}

function handleRemove({ id }) {
  return api
    .delete(`/Escolaridade/id/${id}`)
    .then((res) => res)
    .catch((err) => handleError("Erro ao incluir", err));
}

export const gridDataSource = {
  store: new CustomStore({
    key: ["id"],
    load: handleLoad,
    insert: handleInsert,
    update: handleUpdate,
    remove: handleRemove,
  }),
};
